class UrlParser {

    parse(url) {
        return {
            params: this.getParams(url)
        }
    }

    getParams(url) {
        let params = {};
        let parser = document.createElement('a');
        parser.href = url;
        let query = parser.search.substring(1);
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            params[pair[0]] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    hasParams(url, keys) {

        const {params} = this.parse(url)
        let res = true

        keys.forEach((key)  => {
             if(params[key] === undefined)
                 res = false
        })

        return res
    }

}

export default new UrlParser


// WEBPACK FOOTER //
// ./resources/assets/js/modules/UrlParser.js